import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFire = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 15,
	height: 22,
	fill: "none",
	viewBox: "0 0 15 22",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#FFC700",
		stroke: "#FF5353",
		strokeWidth: .833274,
		d: "M14.3448 15.4385C13.8762 19.0989 10.1866 21.5 7.49259 21.5C3.8323 21.5 1.51894 18.1032 0.904002 15.7606C0.289068 13.418 1.43111 10.7533 2.54385 9.64056C3.65659 8.52782 5.61854 6.62445 6.55559 1.5C12.9685 7.59078 14.8133 11.7782 14.3448 15.4385Z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#FF5353",
		d: "M3.41046 14.0949C2.74697 16.7433 4.11663 18.938 5.89862 19.8331C10.0936 20.9423 11.908 17.6721 11.908 14.7712C11.908 12.4372 10.894 11.0996 8.45059 8.00977C9.27998 12.0139 8.45059 14.3786 6.7918 14.3786C5.14323 13.557 6.04747 11.6356 5.61151 11.0996C5.00541 11.6041 3.71667 12.9094 3.41046 14.0949Z"
	})]
});
const ForwardRef = forwardRef(SvgFire);
export default ForwardRef;
